<div class="container">
  <div class="row justify-start">
    <h2 class="col-md-2">{{ isClosed ? "Closed" : "Pending" }} Dispositions</h2>
    <span class="col-md-2">
      <button mat-stroked-button (click)="toggleClosed()" [disabled]="loading">
        View {{ isClosed ? "Pending" : "Closed" }}
      </button>
    </span>
  </div>
  <table mat-table [dataSource]="dispositionTable">
    <ng-container matColumnDef="property">
      <th mat-header-cell *matHeaderCellDef="">Property</th>
      <td mat-cell *matCellDef="let item">
        <ng-container
          *ngTemplateOutlet="
            link;
            context: { value: item.property }
          "></ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="limited_partner">
      <th mat-header-cell *matHeaderCellDef="">Limited Partner</th>
      <td mat-cell *matCellDef="let item">
        @if (item.limited_partner.length) {
          <ul>
            @for (partner of item.limited_partner; track partner) {
              <li>
                <ng-container
              *ngTemplateOutlet="
                link;
                context: { value: partner }
              "></ng-container>
              </li>
            }
          </ul>
        } @else {
          &mdash;
        }
      </td>
    </ng-container>
    <!--    <ng-container matColumnDef="developer">-->
    <!--      <th mat-header-cell *matHeaderCellDef="">Developer</th>-->
    <!--      <td mat-cell *matCellDef="let item">-->
    <!--        <ng-container-->
<!--          *ngTemplateOutlet="-->
<!--            link;-->
<!--            context: { value: item.developer }-->
<!--          "></ng-container>-->
<!--      </td>-->
<!--    </ng-container>-->
    <ng-container matColumnDef="sponsor">
      <th mat-header-cell *matHeaderCellDef="">Primary Sponsor</th>
      <td mat-cell *matCellDef="let item">
        <ng-container
          *ngTemplateOutlet="
            link;
            context: { value: item.sponsor }
          "></ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="year_15">
  <th mat-header-cell *matHeaderCellDef="">Y 15</th>
  <td mat-cell *matCellDef="let item">
    @if (item.year_15?.length) {
      <span>{{ item.year_15 }}</span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="asset_manager">
  <th mat-header-cell *matHeaderCellDef="">Asset Manager</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
          *ngTemplateOutlet="
            link;
            context: { value: item.asset_manager }
          "></ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="originator">
  <th mat-header-cell *matHeaderCellDef="">Originator</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
          *ngTemplateOutlet="
            link;
            context: { value: item.originator }
          "></ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="city">
  <th mat-header-cell *matHeaderCellDef="">City</th>
  <td mat-cell *matCellDef="let item">
    @if (item.city?.length) {
      <span>
        {{ item.city }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="state">
  <th mat-header-cell *matHeaderCellDef="">State</th>
  <td mat-cell *matCellDef="let item">
    @if (item.state?.length) {
      <span>
        {{ item.state }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="units">
  <th mat-header-cell *matHeaderCellDef="">Units</th>
  <td mat-cell *matCellDef="let item">
    @if ($safeNavigationMigration(item?.units) !== null) {
      <span>
        {{ item.units }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="risk_rating">
  <th mat-header-cell *matHeaderCellDef="">Risk Rating</th>
  <td mat-cell *matCellDef="let item">
    @if (item.risk_rating?.length) {
      <span>
        {{ item.risk_rating }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="committee_date">
  <th mat-header-cell *matHeaderCellDef="">Disposition Committee</th>
  <td mat-cell *matCellDef="let item">
    @if (item.committee_date?.length) {
      <span>
        {{ item.committee_date }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="disposition_status">
  <th mat-header-cell *matHeaderCellDef="">Disposition Status</th>
  <td mat-cell *matCellDef="let item">
    @if (item.disposition_status?.length) {
      <span>
        {{ item.disposition_status }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="investor_consent_received">
  <th mat-header-cell *matHeaderCellDef="">Investor Consent Received</th>
  <td mat-cell *matCellDef="let item">
    @if (item.investor_consent_received?.length) {
      <span>
        {{ item.investor_consent_received }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="board_consent_received">
  <th mat-header-cell *matHeaderCellDef="">Board Consent Received</th>
  <td mat-cell *matCellDef="let item">
    @if (item.board_consent_received?.length) {
      <span>
        {{ item.board_consent_received }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="sale_date">
  <th mat-header-cell *matHeaderCellDef="">Sale Date</th>
  <td mat-cell *matCellDef="let item">
    @if (item.sale_date?.length) {
      <span>
        {{ item.sale_date }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="exit_type">
  <th mat-header-cell *matHeaderCellDef="">Exit Type</th>
  <td mat-cell *matCellDef="let item">
    @if (item.exit_type?.length) {
      <span>
        {{ item.exit_type }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="crea_lp_proceeds">
  <th mat-header-cell *matHeaderCellDef="">
    CREA Limited Partner Proceeds
  </th>
  <td
    mat-cell
    *matCellDef="let item"
    class="total_proceeds"
    [class]="{ error: item.proceed_sum !== item.crea_lp_proceeds }">
    <span
          *ngTemplateOutlet="
            number;
            context: { value: item.crea_lp_proceeds }
          "></span>
  </td>
</ng-container>
<ng-container matColumnDef="third_party_fees">
  <th mat-header-cell *matHeaderCellDef="">Third Party Fees</th>
  <td mat-cell *matCellDef="let item">
    <span
          *ngTemplateOutlet="
            number;
            context: { value: item.third_party_fees }
          "></span>
  </td>
</ng-container>
<ng-container matColumnDef="crea_legal_fees">
  <th mat-header-cell *matHeaderCellDef="">CREA Legal Fees</th>
  <td mat-cell *matCellDef="let item">
    <span
          *ngTemplateOutlet="
            number;
            context: { value: item.crea_legal_fees }
          "></span>
  </td>
</ng-container>
<ng-container matColumnDef="am_fees">
  <th mat-header-cell *matHeaderCellDef="">AM Fees</th>
  <td mat-cell *matCellDef="let item">
    <span
    *ngTemplateOutlet="number; context: { value: item.am_fees }"></span>
  </td>
</ng-container>
<ng-container matColumnDef="crea_slp_proceeds">
  <th mat-header-cell *matHeaderCellDef="">CREA SLP Proceeds</th>
  <td mat-cell *matCellDef="let item">
    <span
          *ngTemplateOutlet="
            number;
            context: { value: item.crea_slp_proceeds }
          "></span>
  </td>
</ng-container>
<ng-container matColumnDef="crea_fund_wcr_fee">
  <th mat-header-cell *matHeaderCellDef="">CREA Fund WCR Fees</th>
  <td mat-cell *matCellDef="let item">
    <span
          *ngTemplateOutlet="
            number;
            context: { value: item.crea_fund_wcr_fee }
          "></span>
  </td>
</ng-container>
<ng-container matColumnDef="crea_fund_ut_am_fee">
  <th mat-header-cell *matHeaderCellDef="">CREA Fund UT AM Fees</th>
  <td mat-cell *matCellDef="let item">
    <span
          *ngTemplateOutlet="
            number;
            context: { value: item.crea_fund_ut_am_fee }
          "></span>
  </td>
</ng-container>
<ng-container matColumnDef="crea_disposition_fee">
  <th mat-header-cell *matHeaderCellDef="">CREA Disposition Fees</th>
  <td mat-cell *matCellDef="let item">
    <span
          *ngTemplateOutlet="
            number;
            context: { value: item.crea_disposition_fee }
          "></span>
  </td>
</ng-container>
<ng-container matColumnDef="crea_proceeds">
  <th mat-header-cell *matHeaderCellDef="">CREA Proceeds</th>
  <td mat-cell *matCellDef="let item">
    <span
          *ngTemplateOutlet="
            number;
            context: { value: item.crea_proceeds }
          "></span>
  </td>
</ng-container>
<ng-container matColumnDef="ilp_distribution">
  <th mat-header-cell *matHeaderCellDef="">ILP Distribution</th>
  <td mat-cell *matCellDef="let item">
    <span
          *ngTemplateOutlet="
            number;
            context: { value: item.ilp_distribution }
          "></span>
  </td>
</ng-container>
<ng-container matColumnDef="buyer">
  <th mat-header-cell *matHeaderCellDef="">Buyer</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
          *ngTemplateOutlet="
            item.buyer?.__typename ? link : plain;
            context: { value: item.buyer }
          "></ng-container>
    <ng-template #plain>
      @if (item.buyer?.length) {
        <span>
          {{ item.buyer }}
        </span>
      } @else {
        &mdash;
      }
    </ng-template>
  </td>
</ng-container>
<ng-container matColumnDef="disposition_notes">
  <th mat-header-cell *matHeaderCellDef="">Notes</th>
  <td mat-cell *matCellDef="let item">
    @if (item.disposition_notes?.length) {
      <span>
        {{ item.disposition_notes }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<ng-container matColumnDef="recapture_bond">
  <th mat-header-cell *matHeaderCellDef="">Recapture Bond</th>
  <td mat-cell *matCellDef="let item">
    @if (item.recapture_bond?.length) {
      <span>
        {{ item.recapture_bond }}
      </span>
    } @else {
      &mdash;
    }
  </td>
</ng-container>
<tr mat-header-row *matHeaderRowDef="columns"></tr>
<tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>
</div>
<ng-template let-value="value" #link>
  @if (value?.__typename) {
    <contact-link [subject]="value">
    </contact-link>
  } @else {
    &mdash;
  }
</ng-template>
<ng-template #number let-value="value">
  @if (value !== null) {
    <span>
      <span class="amount">{{ value | currency: "USD":"symbol":"1.0-0" }}</span>
    </span>
  } @else {
    &mdash;
  }
</ng-template>
